import { getFormMeta } from 'redux-form'

export const isFieldActive = (form, field) => {
  const getFormMetaSelector = getFormMeta(form)

  return state => {
    const fieldMeta = getFormMetaSelector(state)[field]

    return Boolean(fieldMeta && fieldMeta.active)
  }
}
